import React from "react";
import { Outlet } from "react-router-dom";
import PageErrorBoundary from "../components/misc/PageErrorBoundary";
import TopBar from "../components/navigation-bars/TopBar";
import { User } from "../types/user";
import { useIsMobile } from "../hooks/useIsMobile";
import AdminSideBar from "../components/navigation-bars/AdminSideBar";
import { SocketProvider } from "../context/SocketContext";
import ImpersonationBanner from "../components/misc/ImpersonationBanner";

interface Props {
    isAdmin: boolean;
    user: User | null;
    isAdminView: boolean;
}

const AdminLayout: React.FC<Props> = ({ isAdmin, user, isAdminView }) => {
    const isMobile = useIsMobile(900);
    return (
        <div className="flex flex-col h-screen">
            {/* Impersonation Banner */}
            <ImpersonationBanner />
            
            {/* TopBar */}
            <header className="h-16 flex items-center px-4 flex-shrink-0">
                <SocketProvider>
                    <TopBar
                        isAdmin={isAdmin}
                        user={user}
                        isAdminView={isAdminView}
                    />
                </SocketProvider>
            </header>

            {/* Main Content Area */}
            <div className="flex flex-1 overflow-hidden">
                {/* SideBar on Desktop */}
                {!isMobile && (
                    <aside className="bg-background text-white flex-shrink-0">
                        <AdminSideBar isAdmin={isAdmin} user={user} />
                    </aside>
                )}

                {/* Page Content */}
                <main
                    className={`flex-1 bg-background overflow-auto ${
                        isMobile ? "pb-20" : ""
                    }`}
                >
                    <PageErrorBoundary>
                        <Outlet />
                    </PageErrorBoundary>
                </main>
            </div>

            {/* SideBar on Mobile */}
            {isMobile && <AdminSideBar isAdmin={isAdmin} user={user} />}
        </div>
    );
};

export default AdminLayout;
